import { render, staticRenderFns } from "./GroupManagementFilters.vue?vue&type=template&id=b37ebe0a&scoped=true&"
import script from "./GroupManagementFilters.vue?vue&type=script&lang=js&"
export * from "./GroupManagementFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37ebe0a",
  null
  
)

export default component.exports